'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    BELMETERUG_URL: '/apiproxy/achmea-klantcontactcenter-communication-v1-opslaanbelmenuverzoek'
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/call-me-now/call-me-now.constants.js
// module id = 848
// module chunks = 0